/// <reference types="@types/googlemaps" />
/**
 * Shop Search extension of Google Maps geocoder which is a service to
 * convert between coordinates(LatLng) and addresses
 */
export class Geocoder {
  private geocoder_: google.maps.Geocoder;

  constructor() {
    this.geocoder_ = new google.maps.Geocoder();
  }

  /**
   * Given an address string try to convert it to a LatLng type and
   * return success/error as a Promise
   * @param address address to convert into a LatLng
   */
  getCoordinatesFromAddress(address: string) {
    return new Promise<void>((resolve, reject) => {
      this.geocodeAddress(address, resolve, reject);
    });
  }

  /**
   * Given a LatLng/LatLngLiteral type try to convert it to an address.
   * Return success/error as a Promise
   * @param latLng value to be converted to string
   */
  getAddressFromCoordinates(latLng: any) {
    return new Promise<void>((resolve, reject) => {
      this.geocodeCoordinates(latLng, resolve, reject);
    });
  }

  /**
   * GeoCode Address
   * @param address to be converted to LatLng
   * @param resolve function to handle the value if the Promise is resolved
   * @param reject function to handle the value if the Promise is rejected
   */
  private geocodeAddress(address: string, resolve, reject) {
    this.geocoder_.geocode({ address: address }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results.length > 0) {
          const resultsLocation = Object.create({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          });
          resolve(resultsLocation);
        } else {
          reject('no results were found');
        }
      } else {
        reject('there was an error on google maps');
      }
    });
  }

  /**
   * GeoCode coordinates
   * @param location to be converted to an address
   * @param resolve function to handle the value if the Promise is resolved
   * @param reject function to handle the value if the Promise is rejected
   */
  private geocodeCoordinates(location: any, resolve, reject) {
    this.geocoder_.geocode({ location: location }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results.length > 0) {
          resolve(results[0].address_components);
        } else {
          reject('no results were found'); // TODO: probably need to handle these errors
        }
      } else {
        reject('there was an error on google maps');
      }
    });
  }
}
